import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1.5 12a10.5 10.5 0 1 0 21 0 10.5 10.5 0 1 0-21 0M12 12V8.25M12 12l4.687 4.688"
    }, null, -1)
  ]));
}
const interfaceTimeClockCircle = { render };
export {
  interfaceTimeClockCircle as default,
  render
};
//# sourceMappingURL=interface-time-clock-circle.svg.js.map
